import React from "react";

const UserProfileSidebar = ({ setActiveComponent }) => {
  const handleClick = (componentName) => {
    setActiveComponent(componentName);
  };

  return (
    <div className="bg-black h-screen w-64  top-0 left-0 sticky">
      <div className="flex items-center justify-center mt-10">
        <img
          className="h-10 w-10 rounded-full object-cover"
          src="https://via.placeholder.com/150"
          alt="Profile avatar"
        />
        <h1 className="text-white text-xl font-medium ml-2">User Name</h1>
      </div>

      <nav className="mt-10 flex items-center justify-center">
        <ul>
          <li className="mb-8">
            <a
              href="#"
              className="text-gray-400 hover:text-white block "
              onClick={() => handleClick("ProfileSection")}
            >
              Personal Details
            </a>
          </li>
          <li className="mb-8">
            <a
              href="#"
              className="text-gray-400 hover:text-white block"
              onClick={() => handleClick("Preferences")}
            >
              Preferences
            </a>
          </li>
          <li className="mb-8">
            <a
              href="#"
              className="text-gray-400 hover:text-white block"
              onClick={() => handleClick("Security")}
            >
              Security
            </a>
          </li>
          <li className="mb-8">
            <a
              href="#"
              className="text-gray-400 hover:text-white block"
              onClick={() => handleClick("PaymentDetails")}
            >
              Payment Details
            </a>
          </li>
          <li className="mb-8">
            <a
              href="#"
              className="text-gray-400 hover:text-white block"
              onClick={() => handleClick("PrivacySection")}
            >
              Privacy
            </a>
          </li>
          <li className="mb-8">
            <a
              href="#"
              className="text-gray-400 hover:text-white block"
              onClick={() => handleClick("EmailNotification")}
            >
              Email Notifications
            </a>
          </li>
          <li>
            <a
              href="#"
              className="text-gray-400 hover:text-white block"
              onClick={() => handleClick("OtherTravellers")}
            >
              Other Travellers
            </a>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default UserProfileSidebar;
